/** Spanish Workforce & Education Translations */
export const workforce = {
  workforce: {
    pageTitle: "Dimensión Fuerza Laboral y Educación",
    weightInFII: "peso en el FII",
    heroSubtitle: "Equipando a los jóvenes con habilidades para oportunidades económicas (18-40 años)",
    quote: "El 23% de los trabajadores jóvenes están subempleados en relación con su educación, pero el 85% de los empleos futuros requieren habilidades digitales. La brecha entre educación y oportunidad no es escasez de aprendices—es escasez de caminos alineados y accesibles hacia empleos de calidad.",
    fiiWeightDistribution: "Distribución de peso del FII",
    mentalHealth: "Salud Mental",
    workforceLabel: "Fuerza Laboral",
    entrepreneurship: "Emprendimiento",
    understandCrisis: "Entender la crisis",
    crisisTitle: "La Crisis de Fuerza Laboral y Educación en Números",
    crisisSubtitle: "Estadísticas críticas que afectan la empleabilidad y educación de los jóvenes globalmente",
    crisis: {
      inThree: "de 3",
      stat1Label: "desempleo juvenil global (18-24 años) vs. 5.8% adulto",
      stat2Label: "jóvenes NO en educación, empleo o formación (NEET) globalmente",
      stat3Label: "trabajadores subempleados en relación con su educación",
      stat4Label: "empleos requerirán habilidades digitales para 2030",
      stat5Label: "matrícula promedio global en educación superior (rango: 15%-78%)",
      stat6Label: "jóvenes en África Subsahariana fuera de la fuerza laboral formal",
      stat7Label: "tiempo promedio diario en desarrollo de habilidades digitales",
      stat8Label: "mayor desempleo en mercados emergentes vs. desarrollados",
    },
    severity: {
      crisis: "Crisis",
      severe: "Severo",
      concerning: "Preocupante",
    },
    coreProblem: "El Problema Central",
    coreProblemDesc: "A diferencia de la salud mental (que varía según el bienestar individual), las brechas de fuerza laboral y educación son impulsadas por barreras estructurales: acceso a formación de calidad, disponibilidad de infraestructura digital, alineación del mercado laboral con las habilidades enseñadas y demanda de los empleadores por competencias específicas. Estos son problemas solucionables si JCI los aborda a escala.",
    fiiTitle: "Metodología de Fuerza Laboral del FII",
    fiiSubtitle: "Puntuación de Fuerza Laboral = 30% del Índice de Impacto Futuro",
    subWeight: "sub-peso",
    globalAverage: "Promedio global",
    highest: "Más alto",
    lowest: "Más bajo",
    fii: {
      employmentRate: "Tasa de Empleo Juvenil",
      employmentRateDef: "Porcentaje de 18-40 años en empleo formal (excluyendo trabajo precario)",
      employmentHighest: "Países Nórdicos (85-90%)",
      employmentLowest: "África Subsahariana (45-55%)",
      skillsAlignment: "Alineación de Habilidades",
      skillsAlignmentDef: "Porcentaje de trabajadores cuyas habilidades coinciden con los requisitos del empleo",
      skillsHighest: "Suiza, Alemania (70-75%)",
      skillsLowest: "Sur de Asia (30-35%)",
      educationAccess: "Acceso a la Educación",
      educationAccessDef: "Acceso combinado a educación superior y programas de formación vocacional",
      educationHighest: "Corea del Sur, Finlandia (78%)",
      educationLowest: "Níger, Chad (15%)",
    },
    regionalTitle: "Puntuaciones Regionales de Fuerza Laboral",
    regionalSubtitle: "Dimensión de Fuerza Laboral del FII: Desempeño Regional",
    regions: {
      europe: "Europa",
      asiaPacific: "Asia y el Pacífico",
      americas: "América",
      africaMe: "África y Oriente Medio",
    },
    status: {
      good: "Bueno",
      moderate: "Moderado",
      atRisk: "En Riesgo",
    },
    regional: {
      europeDrivers: "Sistemas de formación dual, educación vocacional fuerte",
      europeOpportunity: "Modelo para programas de formación JCI",
      asiaPacificDrivers: "Variación económica: Japón/Corea alto, Sur de Asia bajo",
      asiaPacificOpportunity: "Alfabetización digital y alianzas de habilidades tecnológicas",
      americasDrivers: "Norteamérica fuerte, Latinoamérica tiene brechas",
      americasOpportunity: "Escalabilidad de programas JCI + CYE",
      africaMeDrivers: "Población joven, escasez de infraestructura",
      africaMeOpportunity: "Mayor impacto potencial—formación mobile-first",
    },
    employment: "Empleo",
    skillsLabel: "Habilidades",
    education: "Educación",
    projectionTitle: "Proyección 2024 vs 2040",
    skillsTitle: "Panorama Global de Habilidades",
    skillsSubtitle: "Análisis de la brecha entre oferta y demanda de habilidades",
    hardSkills: "Habilidades Técnicas",
    softSkills: "Habilidades Blandas",
    supply: "Oferta",
    demand: "Demanda",
    skillNames: {
      dataAnalytics: "Análisis de Datos",
      cloudComputing: "Computación en la Nube",
      aiMl: "IA/Machine Learning",
      cybersecurity: "Ciberseguridad",
      projectMgmt: "Gestión de Proyectos",
      criticalThinking: "Pensamiento Crítico",
      communication: "Comunicación",
      adaptability: "Adaptabilidad",
      leadership: "Liderazgo",
      creativity: "Creatividad",
    },
    deepDiveTitle: "Análisis Regionales Detallados",
    deepDiveSubtitle: "Análisis profundo de fuerza laboral y educación por región JCI",
    strengths: "Fortalezas",
    challenges: "Desafíos",
    jciOpportunity: "Oportunidad JCI",
    deepDive: {
      europe: {
        strength1: "Sistema de educación dual (Alemania, Austria, Suiza)",
        strength2: "Alta inversión en I+D e innovación",
        strength3: "Fuerte protección laboral y beneficios",
        challenge1: "Envejecimiento de la fuerza laboral",
        challenge2: "Brechas de habilidades digitales en algunas regiones",
        challenge3: "Desempleo juvenil en el sur de Europa",
        opportunity: "Exportar modelos de formación dual a otras regiones",
      },
      asiaPacific: {
        strength1: "Alta valoración cultural de la educación",
        strength2: "Rápida adopción de tecnología",
        strength3: "Fuerza laboral joven y creciente",
        challenge1: "Desigualdad de acceso entre países",
        challenge2: "Desajuste entre educación y mercado",
        challenge3: "Alta competencia por empleos formales",
        opportunity: "Programas de habilidades digitales mobile-first",
      },
      americas: {
        strength1: "Ecosistema de innovación fuerte (EE.UU., Canadá)",
        strength2: "Espíritu emprendedor creciente",
        strength3: "Diversidad de talentos",
        challenge1: "Desigualdad de acceso a educación de calidad",
        challenge2: "Alto costo de la educación superior",
        challenge3: "Subempleo de graduados",
        opportunity: "Escalar programas JIB + CYE en Latinoamérica",
      },
      africaMe: {
        strength1: "Población más joven del mundo",
        strength2: "Alta aspiración emprendedora",
        strength3: "Crecimiento del ecosistema digital",
        challenge1: "Infraestructura educativa limitada",
        challenge2: "Alto desempleo juvenil (14-16%)",
        challenge3: "Brecha de financiamiento crítica",
        opportunity: "Formación mobile-first y microfinanzas para jóvenes",
      },
    },
    initiativesTitle: "Iniciativas Actuales de JCI",
    initiativesSubtitle: "Programas de fuerza laboral y educación de JCI",
    program: "Programa",
    reach: "Alcance",
    target: "Público Objetivo",
    statusLabel: "Estado",
    initiatives: {
      jibName: "JCI Jóvenes en Negocios (JIB)",
      jibTarget: "Jóvenes emprendedores (18-30)",
      jibDesc: "Formación en alfabetización empresarial y lanzamiento de startups",
      cyeName: "Emprendimiento Creativo de la Juventud (CYE)",
      cyeTarget: "Jóvenes creativos (16-25)",
      cyeDesc: "Programa de habilidades creativas y emprendimiento",
      digitalName: "Academia Digital JCI",
      digitalTarget: "Todos los jóvenes (18-40)",
      digitalDesc: "Formación en habilidades digitales y alfabetización tecnológica",
      mentoringName: "Red de Mentoría JCI",
      mentoringTarget: "Jóvenes profesionales (22-35)",
      mentoringDesc: "Conexión mentor-mentoreado para desarrollo de carrera",
      riseName: "Proyectos RISE",
      riseTarget: "Comunidades en riesgo",
      riseDesc: "Proyectos de impacto comunitario enfocados en empleo",
      statusActive: "Activo",
      statusGrowing: "En Crecimiento",
      statusExpanding: "En Expansión",
    },
    outcomesTitle: "Resultados y Estudios de Caso",
    outcomesSubtitle: "Impacto medible de los programas de fuerza laboral de JCI",
    cases: {
      paraguayCountry: "Paraguay",
      paraguayTitle: "JCI Asunción Digital Skills",
      paraguayOutcome: "Programa de formación digital para jóvenes desempleados resultó en alta tasa de empleabilidad",
      paraguayMetric: "tasa de empleabilidad",
      syriaCountry: "Siria (Refugiados)",
      syriaTitle: "JCI Refugee Skills Initiative",
      syriaOutcome: "Formación vocacional para jóvenes refugiados sirios en países vecinos",
      syriaMetric: "jóvenes formados",
      boliviaCountry: "Bolivia",
      boliviaTitle: "JCI Santa Cruz Emprende",
      boliviaOutcome: "Programa de microemprendimiento para jóvenes de comunidades rurales",
      boliviaMetric: "empresas lanzadas",
    },
    actionsTitle: "Acciones Recomendadas para JCI",
    actionsSubtitle: "Prioridades estratégicas para cerrar la brecha de fuerza laboral",
    actions: {
      action1Title: "Escalar Academia Digital",
      action1Desc: "Expandir formación en habilidades digitales a todas las regiones, priorizando África/MO",
      action1Effort: "12-18 meses",
      action1Impact: "3x alcance",
      action2Title: "Alianzas Corporativas",
      action2Desc: "Desarrollar alianzas con empleadores para garantizar caminos de empleo",
      action2Effort: "6-12 meses",
      action2Impact: "Empleabilidad +40%",
      action3Title: "Educación Vocacional",
      action3Desc: "Crear programas de formación vocacional alineados al mercado",
      action3Effort: "18-24 meses",
      action3Impact: "Modelo sostenible",
      action4Title: "Mentoría a Escala",
      action4Desc: "Expandir red de mentoría a 50,000+ conexiones activas",
      action4Effort: "24-36 meses",
      action4Impact: "Desarrollo de carrera",
      action5Title: "Certificaciones Reconocidas",
      action5Desc: "Desarrollar certificaciones JCI reconocidas por empleadores globales",
      action5Effort: "18-24 meses",
      action5Impact: "Credibilidad global",
      action6Title: "Fondo de Microfinanzas",
      action6Desc: "Crear fondo de microfinanzas para jóvenes emprendedores en mercados emergentes",
      action6Effort: "12-18 meses",
      action6Impact: "Acceso a capital",
    },
    ctaTitle: "Fuerza Laboral es el Habilitador",
    ctaDescription: "Fuerza laboral y educación conectan salud mental (fundación) con emprendimiento (acelerador). Los jóvenes empleados tienen mejor salud mental, más confianza y capacidad para iniciar negocios.",
    exploreFII: "Explorar FII",
    exploreMentalHealth: "Explorar Salud Mental",
    dataSources: { title: "Fuentes de Datos" },
  },
} as const;
